import { BookServiceService } from "./../../../services/book-service.service";
import { Component, OnInit } from "@angular/core";
import { Subscription } from "rxjs";

@Component({
  selector: "app-user-profile",
  templateUrl: "./user-profile.component.html",
  styleUrls: ["./user-profile.component.scss"]
})
export class UserProfileComponent implements OnInit {
  books: any;
  sub: Subscription;
  constructor(private ser: BookServiceService) {}

  ngOnInit() {
    this.sub = this.ser.allBooks().subscribe(data => {
      this.books = data.map(el => {
        return {
          id: el.payload.doc.id,
          ...el.payload.doc.data()
        };
      });
    });
  }
}
